import { Box, Paper, Typography } from "@mui/material";
import GlobeH from "../../../dashboard/dashboard_components/map";

const MapPanel = ({paper_sx}) => (
  <Paper sx={{ ...paper_sx, maxHeight: 320, p: 1.5, overflow: "hidden"}} elevation={3}>
    <Typography sx={{ fontSize: 13, fontWeight: 500, color: "#888", mb: 0.5, px: 0.5 }}>
      Map
    </Typography>
    <Box sx={{ height: "calc(100% - 26px)", minHeight: 280 }}>
      <GlobeH />
    </Box>
  </Paper>
);

export default MapPanel;
